import React, { useState } from 'react';
import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import {useResponsive} from '../../hooks/use-responsive';

export default function ClickableTooltip({ title, children }) {
    const lgUp = useResponsive('up', 'lg');
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    // Usamos React.cloneElement para añadir el prop 'onClick' al hijo que nos pasen (el IconButton)
    const childWithClick = React.cloneElement(children, {
        onClick: handleOpen,
    });

    if(lgUp) {
        return (
            <Tooltip
                title={title}
                arrow
            >
                {childWithClick}
            </Tooltip>
        );
    }

    return (
        <Tooltip
        open={open}
        onClose={handleClose}
        title={title}
        arrow
        >
        {childWithClick}
        </Tooltip>
    );
}

ClickableTooltip.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.element.isRequired,
};